import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import { Page } from "../common/Page";
import { ToggleableProps } from "../common/Toggleable";

export const AgentPageLayout = function (props: {
    list: any,
    detail: any,
    detailModal: any,
    toggle?: ToggleableProps,
}) {

    const { toggle } = props;
    return (
        <Page name="Agents">
            <Layout style={{ height: "100%" }} >
                <Content style={{overflowY: "auto" }}>
                    {props.list}
                </Content>
            </Layout>
            <Sider width="100%" collapsedWidth={"0"} collapsed={!(toggle && toggle.visible)}>
                {props.detail}
            </Sider>

            {props.detailModal}

        </Page>
    );

}
